import React, { Component } from 'react';
import logo from '../../assets/logo-wht.svg';
import './NotLaunched.scss';

class NotLaunched extends Component {
    render() {
        return (
            <div className={'NotLaunched'}>
                <div className={'not-launched-container'}>
                    <div className={'not-launched'}>
                        
                    <div className="logo">
                            <img src={logo} />
                        </div>

                        <h1>Tickets on sale March 15th, 9am</h1>

                        
                    </div>
                </div>
            </div>
        );
    }
}

export default NotLaunched;